module.exports = __webpack_public_path__ + "static/media/GENESIS.ed3681a2.png";